var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkype = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "skype_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7495"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18864"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18706"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#skype_svg__a)",
  "data-name": "Group 18705"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.754 20.938a9.167 9.167 0 0 0 10.888 9.006 5.352 5.352 0 0 0 7.309-7.407 9.167 9.167 0 0 0-10.716-10.611 5.351 5.351 0 0 0-7.335 7.383 9 9 0 0 0-.148 1.629m9.268-6.515c2.957.174 4.689 1.474 4.857 2.689a1.245 1.245 0 0 1-1.361 1.411c-1.338 0-1.474-1.783-3.777-1.783-1.039 0-1.916.432-1.916 1.368 0 1.959 7.38.821 7.38 5.132 0 2.485-1.989 4.113-4.958 4.113-2.612 0-5.236-1.183-5.223-3.221a1.144 1.144 0 0 1 1.073-1.18c1.538 0 1.524 2.285 3.973 2.285 1.717 0 2.3-.937 2.3-1.59 0-2.359-7.424-.913-7.424-5.349 0-2.4 1.972-4.057 5.072-3.875",
  "data-name": "Path 27247"
}))))));
export { SvgSkype as ReactComponent };
export default __webpack_public_path__ + "static/media/skype.afd4eb7b1190389c35c2c09377eb3ae5.svg";